export const OFFICE_INITIALIZED = 'OFFICE_INITIALIZED';
export const OFFICE_UNINITIALIZED = 'OFFICE_UNINITIALIZED';
export const CHANGE_ALERT_TEXT = 'CHANGE_ALERT_TEXT';
export const CLEAR_ALERT_TEXT = 'CLEAR_ALERT_TEXT';
export const SET_INITIALIZATION_ERROR = 'SET_INITIALIZATION_ERROR';
export const IS_LOADING = 'IS_LOADING';
export const CHANGE_EMAIL = 'CHANGE_EMAIL';
export const IS_SYNCING_ATTACHMENTS = 'IS_SYNCING_ATTACHMENTS';
export const EMAIL_SELECTED = 'EMAIL_SELECTED';
export const CALENDAR_SELECTED = 'CALENDAR_SELECTED';
export const changeEmail = () => {
  return {
    type: CHANGE_EMAIL,
  };
};

export const emailSelected = () => {
  return {
    type: EMAIL_SELECTED,
  };
};

export const calendarSelected = () => {
  return {
    type: CALENDAR_SELECTED,
  };
};

export const officeInitialized = () => {
  return {
    type: OFFICE_INITIALIZED,
  };
};

export const officeUninitialized = () => {
  return {
    type: OFFICE_UNINITIALIZED,
  };
};

// Unless explicitly otherwise, we can assume the status of an alert is a success.
export const changeAlertText = (alertText, status = 'success') => ({
  type: CHANGE_ALERT_TEXT,
  payload: {
    text: alertText,
    status,
  },
});

export const clearAlertText = () => ({
  type: CLEAR_ALERT_TEXT,
});

export const setInitializationError = (status) => ({
  type: SET_INITIALIZATION_ERROR,
  status,
});

export const isLoading = (value) => ({
  type: IS_LOADING,
  payload: value,
});

export const isSyncingAttachments = (value) => ({
  type: IS_SYNCING_ATTACHMENTS,
  payload: value,
});

